<template>
  <a-modal
    class="appointment-time-modal"
    :visible="visible"
    title="可预约时间段查看"
    width="430px"
    :confirm-loading="loading"
    @cancel="handleCancel"
  >
    <div class="date-show">
      <a-icon class="change-date-icon" type="caret-left" @click="prevDay" />
      <span style="font-size: 22px">{{ currentDate }}</span>
      <a-icon class="change-date-icon" type="caret-right" @click="nextDay" />
    </div>
    <ls-table-layout>
      <div class="table-page-search-wrapper" slot="search">
        <ls-search-form class="search-part" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
          <global-select
            slot="deliverLiftCode"
            :value.sync="queryParams.deliverLiftCode"
            :selectData="deliverLiftList"
            selectType="selectFilter"
            :selectItem="{ value: 'lookupCode', label: 'attribute1' }"
          />
        </ls-search-form>
      </div>
      <template v-slot:table>
        <div class="page-header-content">
          <!-- 表格 -->
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            :multi-select="true"
            rowKey="id"
            :scroll="{ y: 300 }">
            <template slot="startFreeTime" slot-scope="{ record }">
              <span v-if="record.startFreeTime">{{ $moment(record.startFreeTime).format('HH:mm') + '~' + $moment(record.endFreeTime).format('HH:mm') }}</span>
            </template>
          </ls-api-table>
        </div>
      </template>
    </ls-table-layout>
    <template #footer>
      <div class="footer-btn-wrapper">
        <a-button type="primary" @click="handleCancel">关闭</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import { generateLsTableResData } from '@/utils/util'
import { apiGetApptsLiftFreeTimes } from '@/api/scp/materialReservationManagement/materialReservation'

export default {
  name: 'AppointmentTimeModal',
  data () {
    return {
      currentDate: '', // 新增，默认今天
      visible: false,
      loading: false,
      queryParams: {
        deliverLiftCode: undefined
      },
      formList: [
        { label: '货梯', decorator: ['deliverLiftCode'], type: 'deliverLiftCode' }
      ],
      // 表格字段
      columns: [
        { title: '货梯', dataIndex: 'deliverLiftCodeName', align: 'center', width: 150 },
        { title: '空闲时段', dataIndex: 'startFreeTime', scopedSlots: { customRender: 'startFreeTime' }, align: 'center' }
      ],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetApptsLiftFreeTimes, false),
        pageCurrent: true
      },
      selectedData: [] // 勾选的数据
    }
  },
  props: {
    deliverLiftList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // 获取今天日期
    getToday() {
      return this.$moment(new Date()).format('YYYY-MM-DD'); // 'YYYY-MM-DD'
    },
    // 上一天
    prevDay() {
      this.currentDate = this.$moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD');
      this.onSearch();
    },
    // 下一天
    nextDay() {
      this.currentDate = this.$moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD');
      this.onSearch();
    },
    // 显示弹窗
    show(data) {
      this.queryParams.deliverLiftCode = data?.deliverLiftCode || undefined
      this.currentDate = this.getToday()
      this.visible = true
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 取消
    handleCancel () {
      this.visible = false
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      params.searchTime = this.currentDate + ' 00:00:00'
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = { deliverLiftCode: undefined }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style lang="less" scoped>
.appointment-time-modal{
  /deep/ .ant-modal-body{
    padding: 12px 20px;
  }
}
.date-show{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}
.change-date-icon{
  cursor:pointer;
  margin: 0 18px;
  font-size: 25px;
}
.search-part{
  /deep/ .ant-form-item-label{
    width: 60px !important;
    min-width: 60px !important;
  }
}
</style>
